import React, {Component} from 'react';
import ReactGA from "react-ga";

export interface LinkWithGATrackerProps {
  href: string,
  className: string,
  onClick: (e: any) => void
  target: string,
  children?: JSX.Element[] | JSX.Element
}

export default class LinkWithGATracker extends Component<LinkWithGATrackerProps> {
  propsWithGATracker: LinkWithGATrackerProps;

  constructor(props: LinkWithGATrackerProps) {
    super(props);

    this.propsWithGATracker = this.initPropsWithGATracker();

    Object.assign(this.propsWithGATracker, this.props, {
      onClick: (e: any) => {
        if (window.hasOwnProperty("ga")) {
          ReactGA.pageview("/foundry" + this.props.href);
        }
        this.props.onClick(e);
      }
    })
  }


  initPropsWithGATracker() {
    return {
      href: "",
      className: "",
      onClick: () => {},
      target: "",
      children: undefined
    }
  }

  render() {
    return (<a {...this.propsWithGATracker}>
      {this.props.children}
    </a>)
  }
}
